/**
 * The material resource types `createMaterialFromContent` can build, which its guard
 * reads. A producer asks this before minting an address, or a present, correct file
 * shows as missing. THREE-free, so the decoders that read it do not import the renderer.
 */
export const BUILDABLE_MATERIAL_TYPES = new Set([
    'StandardMaterial3D',
    'ShaderMaterial',
]);
//# sourceMappingURL=buildableMaterialTypes.js.map